import type { ECharts } from 'echarts'

export interface RulerPlotRect { x: number; y: number; width: number; height: number }

/** Read the resolved grid, including the space ECharts reserves for axis labels. */
export function getRulerPlotRect(chart: ECharts): RulerPlotRect | null {
  // ECharts exposes this model at runtime but marks it private in its declarations.
  // Keep that dependency here; option.grid alone omits containLabel adjustments.
  const model = (chart as unknown as {
    getModel?: () => { getComponent: (type: string, index: number) => {
      coordinateSystem?: { getRect: () => RulerPlotRect }
    } | undefined }
  }).getModel?.()
  const rect = model?.getComponent('grid', 0)?.coordinateSystem?.getRect()
  return rect && [rect.x, rect.y, rect.width, rect.height].every(Number.isFinite)
    && rect.width > 0 && rect.height > 0
    ? { x: rect.x, y: rect.y, width: rect.width, height: rect.height }
    : null
}
